export const CLASS_STICKY = 'is-sticky';
export const CLASS_INITIALISED = 'is-initialised';
export const CLASS_DISABLED = 'is-disabled';
export const CLASS_PENDING = 'is-pending';
export const CLASS_ACTIVE = 'is-active';
export const CLASS_VISIBLE = 'is-visible';
export const CLASS_SCROLL_DISABLED = 'is-scroll-disabled';
export const CLASS_SLICK_INITIALISED = 'slick-initialized';
export const CLASS_HIDDEN = 'is-hidden';
